/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ExternalEmrDocumentPullRequest,
  GetExternalEmrDocuments200Response,
  StartExternalEmrDocumentPull201Response,
} from '../models/index';
import {
    ExternalEmrDocumentPullRequestFromJSON,
    ExternalEmrDocumentPullRequestToJSON,
    GetExternalEmrDocuments200ResponseFromJSON,
    GetExternalEmrDocuments200ResponseToJSON,
    StartExternalEmrDocumentPull201ResponseFromJSON,
    StartExternalEmrDocumentPull201ResponseToJSON,
} from '../models/index';

export interface GetExternalEmrDocumentsRequest {
    leadId: string;
}

export interface StartExternalEmrDocumentPullRequest {
    leadId: string;
    externalEmrDocumentPullRequest?: ExternalEmrDocumentPullRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * List a lead\'s external EMR documents and the current pull state
     */
    async getExternalEmrDocumentsRaw(requestParameters: GetExternalEmrDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExternalEmrDocuments200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getExternalEmrDocuments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/emr-documents`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExternalEmrDocuments200ResponseFromJSON(jsonValue));
    }

    /**
     * List a lead\'s external EMR documents and the current pull state
     */
    async getExternalEmrDocuments(requestParameters: GetExternalEmrDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExternalEmrDocuments200Response> {
        const response = await this.getExternalEmrDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Scoped to the lead because the lead\'s facility resolves the Net Health consumer site, and one external EHR patient can be linked to leads in several facilities. Idempotent — returns is_started false when a pull is already running for the patient. 422 when external EMR document retrieval is not enabled for the lead\'s facility.
     * Start an external EMR document pull for a lead\'s patient
     */
    async startExternalEmrDocumentPullRaw(requestParameters: StartExternalEmrDocumentPullRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartExternalEmrDocumentPull201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling startExternalEmrDocumentPull.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-leads/{lead_id}/emr-document-pulls`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalEmrDocumentPullRequestToJSON(requestParameters.externalEmrDocumentPullRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StartExternalEmrDocumentPull201ResponseFromJSON(jsonValue));
    }

    /**
     * Scoped to the lead because the lead\'s facility resolves the Net Health consumer site, and one external EHR patient can be linked to leads in several facilities. Idempotent — returns is_started false when a pull is already running for the patient. 422 when external EMR document retrieval is not enabled for the lead\'s facility.
     * Start an external EMR document pull for a lead\'s patient
     */
    async startExternalEmrDocumentPull(requestParameters: StartExternalEmrDocumentPullRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartExternalEmrDocumentPull201Response> {
        const response = await this.startExternalEmrDocumentPullRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
